import { User, Roles, Sex } from './user.model'
import { RelationshipForm } from './relationship-form.model'
import { Relationship } from './relationship.model'
import * as moment from 'moment'

export class UserForm {
  id: string
  firstname: string
  lastname: string
  maidenName: string
  avatar: string
  sex: string
  password: string
  newPassword: string
  dob: moment.Moment
  dop: moment.Moment
  email: string
  address: string
  city: string
  zipcode: string
  country: string
  role: string
  relationships: RelationshipForm[] = []
  notificationsPublicNew: boolean
  notificationsPublicUpcoming: boolean
  notificationsPublicDeleted: boolean
  notificationsPublicDate: boolean
  notificationsPrivateNew: boolean
  notificationsPrivateUpcoming: boolean
  notificationsPrivateDeleted: boolean
  notificationsPrivateDate: boolean
  notificationsComment: boolean

  fill (user: User) {
    this.id = user.id
    this.firstname = user.firstname
    this.lastname = user.lastname
    this.maidenName = user.maidenName
    this.avatar = user.avatar
    this.sex = Sex[user.sex]
    this.dob = user.dob
    this.dop = user.dop
    this.email = user.email
    this.address = user.address
    this.city = user.city
    this.zipcode = user.zipcode
    this.country = user.country
    this.role = Roles[user.role]
    this.relationships = user.relationships.map((r) => new RelationshipForm().fill(r))
    this.notificationsPublicNew = user.notificationsPublicNew
    this.notificationsPublicUpcoming = user.notificationsPublicUpcoming
    this.notificationsPublicDeleted = user.notificationsPublicDeleted
    this.notificationsPublicDate = user.notificationsPublicDate
    this.notificationsPrivateNew = user.notificationsPrivateNew
    this.notificationsPrivateUpcoming = user.notificationsPrivateUpcoming
    this.notificationsPrivateDeleted = user.notificationsPrivateDeleted
    this.notificationsPrivateDate = user.notificationsPrivateDate
    this.notificationsPrivateDate = user.notificationsPrivateDate
    this.notificationsComment = user.notificationsComment
  }

  update (user: User) {
    user.id = this.id
    user.firstname = this.firstname
    user.lastname = this.lastname
    user.maidenName = this.maidenName
    user.avatar = this.avatar
    user.sex = Roles[this.sex]
    user.dob = this.dob
    user.dop = this.dop
    user.email = this.email
    user.address = this.address
    user.city = this.city
    user.zipcode = this.zipcode
    user.country = this.country
    user.role = Roles[this.role]
    user.relationships = this.relationships.map((r) => new Relationship().cast(r))
    user.notificationsPublicNew = this.notificationsPublicNew
    user.notificationsPublicUpcoming = this.notificationsPublicUpcoming
    user.notificationsPublicDeleted = this.notificationsPublicDeleted
    user.notificationsPublicDate = this.notificationsPublicDate
    user.notificationsPrivateNew = this.notificationsPrivateNew
    user.notificationsPrivateUpcoming = this.notificationsPrivateUpcoming
    user.notificationsPrivateDeleted = this.notificationsPrivateDeleted
    user.notificationsPrivateDate = this.notificationsPrivateDate
    user.notificationsPrivateDate = this.notificationsPrivateDate
    user.notificationsComment = this.notificationsComment
  }

  generateSelectRole () {
    return Object.keys(Roles)
      .filter(key => !isNaN(parseInt(key, 10)))
      .map((el, index) => {
        return {
          value: Roles[index],
          label: new User().getRoleLabel(index) }
      })
  }

  generateSelectSex () {
    return Object.keys(Sex)
      .filter(key => !isNaN(parseInt(key, 10)))
      .map((el, index) => {
        return {
          value: Sex[index],
          label: new User().getSexLabel(index) }
      })
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/user-form.model.ts